import React from 'react';
import { Modal, ModalBody, ModalHeader, Table } from 'reactstrap';
import './OrganisationWidget.scss';

function ReporteeModal({ isOpen, toggle, data, header }) {
  const renderTableBody = () => {
    if (data?.length === 0) {
      return (
        <tr>
          <td colSpan="4" className="text-center">
            No {header} Reports found.
          </td>
        </tr>
      );
    }

    return data?.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td title={item.EmpName}>{item.EmpName}</td>
        <td title={item.EmpCd}>{item.EmpCd}</td>
        <td title={item.Designation}>{item.Designation}</td>
        <td title={item.DirectMgrName}>{item.DirectMgrName}</td>
      </tr>
    ));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
      <ModalHeader toggle={toggle}>{header} Reports</ModalHeader>
      <ModalBody>
        <div
          className="table-responsive"
          id="reportee-table-container"
          style={{
            border: '2px solid #D0D5DD',
            borderRadius: '8px',
          }}
        >
          <Table className="custom-table mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Employee Code</th>
                <th>Designation</th>
                <th>Manager</th>
              </tr>
            </thead>
            <tbody>{renderTableBody()}</tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ReporteeModal;
